import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import ConfirmButton, {
  ConfirmButtonTransitionState
} from "@saleor/components/ConfirmButton";
import FormSpacer from "@saleor/components/FormSpacer";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import SingleAutocompleteSelectField from "@saleor/components/SingleAutocompleteSelectField";
// import TableCellAvatar from "@saleor/components/TableCellAvatar";
import useSearchQuery from "@saleor/hooks/useSearchQuery";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { buttonMessages } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { SearchCategories_search_edges_node } from "@saleor/searches/types/SearchCategories";
import {
  SearchProducts_search_edges_node
  // SearchProducts_search_edges_node_variants
} from "@saleor/searches/types/SearchProducts";
import useScrollableDialogStyle from "@saleor/styles/useScrollableDialogStyle";
import { FetchMoreProps } from "@saleor/types";
import createSingleAutocompleteSelectHandler from "@saleor/utils/handlers/singleAutocompleteSelectChangeHandler";
import React from "react";
import InfiniteScroll from "react-infinite-scroller";
import { FormattedMessage, useIntl } from "react-intl";

import Checkbox from "../Checkbox";
import Form from "../Form";
export interface FormData {
  products: SearchProducts_search_edges_node[];
  query: string;
  onBrandChange(event: React.ChangeEvent<any>);
}

const useStyles = makeStyles(
  {
    avatar: {
      "&&:first-child": {
        paddingLeft: 0
      },
      width: 72
    },
    checkboxCell: {
      paddingLeft: 0,
      width: 88
    },
    colName: {
      paddingLeft: 0
    }
  },
  { name: "AssignDiscountSaleProductDialog" }
);

export interface AssignDiscountSaleProductDialogProps extends FetchMoreProps {
  confirmButtonState: ConfirmButtonTransitionState;
  categories: SearchCategories_search_edges_node[];
  open: boolean;
  fetchMoreCategories: FetchMoreProps;
  products: SearchProducts_search_edges_node[];
  loading: boolean;
  selectCategory: (value) => void;
  fetchCategories: (query: string) => void;
  onClose: () => void;
  onFetch: (value: string) => void;
  onSubmit: (data: SearchProducts_search_edges_node[]) => void;
  // onSubmit: (data: SearchProducts_search_edges_node_variants[]) => void;
}

function handleProductAssign(
  product: SearchProducts_search_edges_node,
  isSelected: boolean,
  selectedProducts: SearchProducts_search_edges_node[],
  setSelectedProducts: (data: SearchProducts_search_edges_node[]) => void
) {
  if (isSelected) {
    setSelectedProducts(
      selectedProducts.filter(
        selectedProduct => selectedProduct.id !== product.id
      )
    );
  } else {
    setSelectedProducts([...selectedProducts, product]);
  }
}

// function handleProductAssign(
//   product: SearchProducts_search_edges_node_variants,
//   isSelected: boolean,
//   selectedProducts: SearchProducts_search_edges_node_variants[],
//   setSelectedProducts: (
//     data: SearchProducts_search_edges_node_variants[]
//   ) => void
// ) {
//   if (isSelected) {
//     setSelectedProducts(
//       selectedProducts.filter(
//         selectedProduct => selectedProduct.id !== product.id
//       )
//     );
//   } else {
//     setSelectedProducts([...selectedProducts, product]);
//   }
// }

const AssignDiscountSaleProductDialog: React.FC<AssignDiscountSaleProductDialogProps> = props => {
  const {
    confirmButtonState,
    categories,
    hasMore,
    open,
    loading,
    selectCategory,
    fetchCategories,
    products,

    fetchMoreCategories,

    onClose,
    onFetch,
    onFetchMore,
    onSubmit
  } = props;
  const classes = useStyles(props);
  const scrollableDialogClasses = useScrollableDialogStyle({});

  const intl = useIntl();
  const [query, onQueryChange] = useSearchQuery(onFetch);
  const [selectedProducts, setSelectedProducts] = React.useState<
    SearchProducts_search_edges_node[]
  >([]);
  // const [selectedProducts, setSelectedProducts] = React.useState<
  //   SearchProducts_search_edges_node_variants[]
  // >([]);
  const container = React.useRef<HTMLDivElement>();

  const [displayValue, setDisplayValue] = useStateFromProps("");

  const categoryChoices = maybe(
    () =>
      categories.map(category => ({
        label: category?.name,
        value: category?.id
      })),
    []
  );

  const initialForm = {
    category: "",
    id: null,
    name: ""
  };
  const handleSubmit = () => onSubmit(selectedProducts);

  return (
    <Form initial={initialForm} onSubmit={handleSubmit} confirmLeave>
      {({ data: formData, change, submit }) => {
        const handleSelectCategory = createSingleAutocompleteSelectHandler(
          change,
          setDisplayValue,
          categoryChoices
        );
        return (
          <Dialog
            onClose={onClose}
            open={open}
            classes={{ paper: scrollableDialogClasses.dialog }}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>
              <FormattedMessage
                defaultMessage="Assign Product"
                description="dialog header"
              />
            </DialogTitle>
            <DialogContent
              className={scrollableDialogClasses.content}
              ref={container}
            >
              <FormSpacer />
              <SingleAutocompleteSelectField
                displayValue={displayValue}
                label={intl.formatMessage({
                  defaultMessage: "Categories"
                })}
                name="category"
                choices={categoryChoices}
                value={formData.category}
                onChange={e => {
                  handleSelectCategory(e);
                  selectCategory(e.target.value);
                }}
                InputProps={{
                  autoComplete: "off"
                }}
                fetchChoices={fetchCategories}
                {...fetchMoreCategories}
              />
              <FormSpacer />
              <TextField
                name="query"
                disabled={formData.category ? false : true}
                value={query}
                onChange={onQueryChange}
                label={intl.formatMessage({
                  defaultMessage: "Search Products"
                })}
                placeholder={intl.formatMessage({
                  defaultMessage:
                    "Search by product name, attribute, product type etc..."
                })}
                fullWidth
                InputProps={{
                  autoComplete: "off",
                  endAdornment: loading && <CircularProgress size={16} />
                }}
              />
              {formData.category ? (
                <>
                  <FormSpacer />
                  <div style={{ height: "320px", overflowY: "auto" }}>
                    <InfiniteScroll
                      pageStart={0}
                      loadMore={onFetchMore}
                      hasMore={hasMore}
                      useWindow={false}
                      loader={
                        <div
                          className={
                            scrollableDialogClasses.loadMoreLoaderContainer
                          }
                          key={0}
                        >
                          <CircularProgress size={16} />
                        </div>
                      }
                      threshold={10}
                    >
                      <ResponsiveTable key="table">
                        <TableBody>
                          {products &&
                            products.map(product => {
                              const isSelected = selectedProducts.some(
                                selectedProduct =>
                                  selectedProduct.id === product.id
                              );

                              return (
                                <TableRow key={product.id}>
                                  <TableCell className={classes.colName}>
                                    {product.name}
                                  </TableCell>
                                  <TableCell
                                    padding="checkbox"
                                    className={classes.checkboxCell}
                                  >
                                    <Checkbox
                                      checked={isSelected}
                                      onChange={() =>
                                        handleProductAssign(
                                          product,
                                          isSelected,
                                          selectedProducts,
                                          setSelectedProducts
                                        )
                                      }
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          {products.length !== 0 ? "" : "No Products Found"}
                        </TableBody>
                      </ResponsiveTable>
                    </InfiniteScroll>
                  </div>
                </>
              ) : null}
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose}>
                <FormattedMessage {...buttonMessages.back} />
              </Button>
              <ConfirmButton
                transitionState={confirmButtonState}
                color="primary"
                disabled={
                  products?.length !== 0 && formData.category ? false : true
                }
                variant="contained"
                type="submit"
                onClick={submit}
              >
                <FormattedMessage
                  defaultMessage="Assign Products"
                  description="button"
                />
              </ConfirmButton>
            </DialogActions>
          </Dialog>
        );
      }}
    </Form>
  );
};
AssignDiscountSaleProductDialog.displayName = "AssignDiscountSaleProductDialog";
export default AssignDiscountSaleProductDialog;

/*
{products &&
                            products.map(product =>
                              product.variants.map(variant => {
                                const isSelected = selectedProducts.some(
                                  selectedProduct =>
                                    selectedProduct.id === variant.id
                                );

                                return (
                                  <TableRow key={variant.id}>
                                    <TableCell className={classes.colName}>
                                      {product.name}, {variant.name}
                                    </TableCell>
                                    <TableCell
                                      padding="checkbox"
                                      className={classes.checkboxCell}
                                    >
                                      <Checkbox
                                        checked={isSelected}
                                        onChange={() =>
                                          handleProductAssign(
                                            variant,
                                            isSelected,
                                            selectedProducts,
                                            setSelectedProducts
                                          )
                                        }
                                      />
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            )}
*/
